import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import PopOver from '../../PopOver/PopOver.js';
import ToggleButton from '../ToggleButton.js';
import Icon from '../../Icon/Icon.js';
import styles from './ToggleButtonElement.module.scss.js';

function ToggleButtonElement(_ref) {
  var isChecked = _ref.isChecked,
    onClick = _ref.onClick,
    text = _ref.text,
    subText = _ref.subText,
    popOverText = _ref.popOverText,
    icon = _ref.icon,
    disabled = _ref.disabled,
    className = _ref.className,
    dark = _ref.dark,
    dataTestId = _ref.dataTestId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    infoTextVisible = _useState2[0],
    setInfoTextVisible = _useState2[1];
  var onClickInfo = function onClickInfo() {
    setInfoTextVisible(true);
    setTimeout(function () {
      return setInfoTextVisible(false);
    }, 10000);
  };
  return /*#__PURE__*/React.createElement("article", {
    className: classNames(styles.toggleButtonElement, disabled && styles.disabled, className)
  }, /*#__PURE__*/React.createElement("section", {
    className: styles.content
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    className: styles.icon
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.textContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.titleContainer
  }, /*#__PURE__*/React.createElement("p", {
    className: classNames('title', styles.text, dark && styles.dark)
  }, text), Boolean(popOverText) && /*#__PURE__*/React.createElement("div", {
    className: styles.popoverContainer
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-info",
    size: "small",
    className: styles.contactIcon,
    onClick: onClickInfo
  }), infoTextVisible && /*#__PURE__*/React.createElement(PopOver, {
    visible: infoTextVisible,
    className: classNames(styles.popover, infoTextVisible && styles.popoverVisible)
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.infoText
  }, popOverText))), /*#__PURE__*/React.createElement(ToggleButton, {
    onClick: onClick,
    dark: dark,
    isChecked: isChecked,
    disabled: disabled,
    dataTestId: dataTestId
  })), Boolean(subText) && /*#__PURE__*/React.createElement("p", {
    className: "secondary"
  }, subText))));
}
ToggleButtonElement.propTypes = {
  isChecked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  subText: PropTypes.string,
  popOverText: PropTypes.string,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  dark: PropTypes.bool,
  dataTestId: PropTypes.string
};
ToggleButtonElement.defaultProps = {
  isChecked: false,
  subText: '',
  popOverText: '',
  icon: '',
  disabled: false,
  className: '',
  dark: false,
  dataTestId: null
};

export { ToggleButtonElement as default };
